<template>
  <div class="goods1">
    <div class="mb20">
      点击删除按钮可以对其置空。点击添加按钮可以添加商品。二维码像素推荐200*200像素。
    </div>
    <el-form :model="currentInfo" label-width="80px">
      <el-form-item label="二维码">
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img
            class="list-img"
            v-if="currentInfo.picture"
            :src="currentInfo.picture"
            @click="updateImg()"
          />
          <i class="el-icon-plus" v-else />
        </el-upload>
      </el-form-item>
      <el-form-item label="电话">
        <el-input placeholder="请输入电话" v-model="currentInfo.title" />
      </el-form-item>
    </el-form>
    <el-tag size="medium">企业新闻</el-tag>
    <div v-if="mixList[0]">
      <div v-for="(item, index) in mixList[0].list" :key="index">
        <div
          class="flex jc-sb cp wx-item-style"
          @click="addGoodSingleBtn(item.id, '企业新闻')"
        >
          <div class="ellipsis">{{ item.schoolPageInfo.title }}</div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            v-if="item.relationId"
            @click.stop="deleteBtn(item.id)"
          ></el-button>
          <el-button type="primary" v-else size="mini">添加</el-button>
        </div>
      </div>
    </div>

    <el-tag size="medium" class="mt20">行业动态</el-tag>
    <div v-if="mixList[1]">
      <div v-for="(item, index) in mixList[1].list" :key="index">
        <div
          class="flex jc-sb cp wx-item-style"
          @click="addGoodSingleBtn(item.id, '行业动态')"
        >
          <div class="ellipsis">{{ item.schoolPageInfo.title }}</div>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
             v-if="item.relationId"
            @click.stop="deleteBtn(item.id)"
          ></el-button>
           <el-button type="primary" v-else size="mini">添加</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],

  data() {
    return {
      mixList: [],
    };
  },
  watch: {
    currentInfo() {
      this.initData();
    },
  },
  methods: {
    initData() {
      let arr = [
        {
          name: "企业新闻",
          list: [],
        },
        {
          name: "行业动态",
          list: [],
        },
      ];
      this.currentInfo.wxSchoolPageItemList.forEach((item) => {
        if (item.remark == "企业新闻") {
          arr[0].list = arr[0].list.concat(item);
        } else {
          arr[1].list = arr[1].list.concat(item);
        }
      });
      this.mixList = arr;
    },

    getChooseIndex(id) {
      let chooseIndex = 0;
      this.currentInfo.wxSchoolPageItemList.forEach((item, index) => {
        if (item.id == id) {
          chooseIndex = index;
        }
      });
      return chooseIndex;
    },
    deleteBtn(id) {
      this.$confirm("确认删除？")
        .then((_) => {
          let chooseIndex = this.getChooseIndex(id);
          this.currentInfo.wxSchoolPageItemList[chooseIndex].isEmpty = 1;
          this.currentInfo.wxSchoolPageItemList[chooseIndex].relationId = "";
          this.currentInfo.wxSchoolPageItemList[chooseIndex].schoolPageInfo =
            {};
        })
        .catch((_) => {});
    },
    //选单个
    addGoodSingleBtn(id, remark) {
      let singleIndex = this.getChooseIndex(id);
      this.$store.commit("design/SET_ADDDIALOGVISIBLE", {
        addDialogVisible: true,
        single: true,
        singleIndex,
        remark,
      });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/module/module1/setting.vue